<template>
    <div>
        <div v-if="showcargando == true"
             id="cargando"
             wire:loading
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verfinanzas" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Fianzas</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <DataTable :name="'finanzas'"
                                       @registro="NumRegistro"
                                       :url="urlListado"
                                       :columns="headFianza"
                                       :params="displayInputs"
                                       :order="[]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="vercaucion" multiple>
                    <v-expansion-panel class="active-class" :key="0">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Cauciones</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <DataTable :name="'cuacion'"
                                       @registro="NumRegistro"
                                       :url="urlCuacion"
                                       :columns="headCuacion"
                                       :params="displayInputs"
                                       :order="[]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verotros" multiple>
                    <v-expansion-panel class="active-class" :key="0">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Otros</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <DataTable :name="'otros'"
                                       @registro="NumRegistro"
                                       :url="urlOtro"
                                       :columns="headOtro"
                                       :params="displayInputs"
                                       :order="[]"
                                       @apiDT="apiDT = $event"
                                       @Cancelar="CancelarShow">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row v-show="pago">
            <v-col cols="12" md="4">
                <v-expansion-panels :value="0">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="orange">Pagos</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <v-simple-table v-if="pagos.length > 0">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Número de factura</th>
                                            <th>Monto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in pagos" :key="item.id">
                                            <td>{{ item.fenumfac }}</td>
                                            <td>{{ item.tmtotal }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <span v-else-if="pagos.length == 0" class="ma-4">
                                <br />
                                No se encontraron registros.
                            </span>
                            <v-col cols="12" class="text-center">
                                <v-btn depressed
                                       @click="cerrar()"
                                       class="ma-2 white--text"
                                       color="orange">
                                    Cerrar
                                </v-btn>
                            </v-col>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn @click="ObtenerPago()"
                       class="ma-2"
                       v-if="verpago == true"
                       color="primary">
                    Ver Pago
                </v-btn>
                <v-btn @click="SolicitarPago()"
                       class="ma-2"
                       v-if="solicitar == true"
                       color="primary">
                    Solicitar Pago
                </v-btn>
                <v-btn @click="PresolicitarPago()"
                       class="ma-2"
                       v-if="solicitar == true && validaPre == true"
                       color="primary">
                    <!--datos.svfhconclusion == '' se quito por validad sino esta cerrado y no es CAP-->
                    Presolicitud Pago
                </v-btn>
                <v-btn @click="AccesoFirma()"
                       class="ma-2"
                       v-if="solicitar == true && validaPre == false"
                       color="primary">
                    Presolicitud Pago
                </v-btn>
                <v-btn @click="Autorizar()"
                       class="ma-2"
                       v-if="presolicitud == true && psid != 0"
                       color="primary">
                    Autorizar solicitud de pagos
                </v-btn>
            </v-col>
        </v-row>
        <div>
            <v-dialog transition="dialog-top-transition"
                      persistent
                      max-width="600"
                      v-model="modal">
                <v-card>
                    <v-toolbar color="primary" dark>Autorización de solicitud de pago</v-toolbar>
                    <v-card-text>
                        <label> Firma electrónica: </label>
                        <br />
                        <v-text-field id="firma"
                                      ref="input"
                                      v-model="firma"
                                      autocomplete="off"
                                      maxlength="17"
                                      style="-webkit-text-security: disc"
                                      @focus="Foco()"
                                      autofocus
                                      solo></v-text-field>
                        <span v-if="msg"
                              id="revfirmaelectronica"
                              style="font-style: italic; color: red">{{ texto }}</span>
                        <br />
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="CerrarModal()">Cerrar</v-btn>
                        <v-btn @click="ValidarFirma()"
                               color="primary"
                               :loading="loading"
                               :disabled="loading">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapMutations, mapState } from "vuex";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import General from "@/services/ReporteGeneral/ReporteGeneral.service.js";
    import TramitePago from "@/services/TramitePago/TramitePago.Service.js";
    import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
        },
        data: function () {
            return {
                verfinanzas: [0],
                vercaucion: [0],
                verotros: [0],
                urlListado: "ReporteGeneral/GarantiasFianzas",
                urlCuacion: "ReporteGeneral/GarantiasCaucion",
                urlOtro: "ReporteGeneral/GarantiasOtros",
                apiDT: null,
                headFianza: [
                    { name: "afianzadora", data: "afianzadora", title: "Afianzadora" },
                    { name: "folio", data: "folio", title: "Folio" },
                    { name: "monto", data: "monto", title: "Monto" },
                    { name: "importe", data: "importe", title: "Importe" },
                    { name: "faplicacion", data: "faplicacion", title: "F. Aplicación" },
                    {
                        name: "frecuperacion",
                        data: "frecuperacion",
                        title: "F. Recuperación",
                    },
                    { name: "concepto", data: "concepto", title: "Concepto" },
                    { name: "efectiva", data: "efectiva", title: "Efectiva" },
                ],
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                },
                headCuacion: [
                    { name: "senumsol", data: "senumsol", title: "Solicitud" },
                    { name: "sefecdocto", data: "sefecdocto", title: "Fecha" },
                    { name: "prnombre", data: "prnombre", title: "Proveedor" },
                    { name: "descripcion", data: "descripcion", title: "Descripción" },
                    { name: "sdtotpart", data: "sdtotpart", title: "Monto" },
                    { name: "sdmonrec", data: "sdmonrec", title: "Recuperado" },
                    { name: "sdfecrec", data: "sdfecrec", title: "Recuperado el" },
                    {
                        name: "irrecuperable",
                        data: "irrecuperable",
                        title: "Irrecuperable",
                    },
                    { name: "PorRecuperar", data: "PorRecuperar", title: "Efectiva" },
                    { name: "sdnobill", data: "sdnobill", title: "No. Billete" },
                ],
                headOtro: [
                    { name: "senumsol", data: "senumsol", title: "Solicitud" },
                    { name: "sefecdocto", data: "sefecdocto", title: "Fecha de Gasto" },
                    { name: "prnombre", data: "prnombre", title: "Proveedor" },
                    { name: "descripcion", data: "descripcion", title: "Descripción" },
                    { name: "sdtotpart", data: "sdtotpart", title: "Monto" },
                    { name: "sefecpagada", data: "sefecpagada", title: "Fecha de Pago" },
                    {
                        name: "cvdescripcion",
                        data: "cvdescripcion",
                        title: "Tipo de viático",
                    },
                ],
                panel: [0],
                datos: {},
                fianza: [],
                caucion: [],
                otros: [],
                pagos: [],
                showcargando: true,
                verpago: false,
                solictudpago: false,
                autorizarsolicitudpago: false,
                solicitar: false,
                presolicitud: false,
                psid: 0,
                cierreotro: false,
                modal: false,
                firma: "",
                msg: false,
                loading: false,
                texto: "",
                validaPre: false,
                pago: false,
                reporte: '',
                asistenciaurl: '',
            };
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            NumRegistro(nombre, count) {
                //console.log(nombre, count);
                if (count > 0) {
                    if (nombre == "finanzas") this.verfinanzas = [0];
                    else if (nombre == "cuacion") this.vercaucion = [0];
                    else if (nombre == "otros") {
                        this.verotros = [0];
                    }
                }
                else {
                    this.verfinanzas = [];
                    this.vercaucion = [];
                    this.verotros = [];
                }
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            CancelarShow() {
                this.showcargando = false;
            },
            cerrar() {
                this.pago = false;
            },
            async ObtenerPago() {
                this.showcargando = true;
                let formData = new FormData();
                formData.append("nrreporte", this.reporte.nrreporte);
                formData.append("svindice", this.reporte.svindice);

                await General.Verpago(this, formData).then((data) => {
                    this.pagos = data;
                });
                this.showcargando = false;
                this.pago = true;
            },
            async SolicitarPago() {
                this.reporte.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, "param");
                this.$router.push({ path: this.asistenciaurl + '/Garantias/SolicitarPago' });
                //switch (this.reporte.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `SolicitarPagoExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `SolicitarPagoRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `SolicitarPagoRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `SolicitarPagoRCMedico` });
                //        break;
                //}
            },
            async PresolicitarPago() {
                this.reporte.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, "param");
                this.$router.push({ path: this.asistenciaurl + '/Garantias/PresolicitudPago' });
                //switch (this.reporte.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `PresolicitudPagoExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `PresolicitudPagoRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `PresolicitudPagoRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `PresolicitudPagoRCMedico` });
                //        break;
                //}
            },
            async permisoPresoli() {
                //presolicitud
                await MetodosGenerales.verificarPermisoSolo(
                    this.domain.domainNameForApi,
                    "VerificarPermiso",
                    "97, 175, 124"
                ).then((response) => {
                    //361 quitar en bd
                    response.data.forEach((object) => {
                        if (object.peclave == 97) this.solicitar = true;
                        else if (object.peclave == 175) this.presolicitud = true;
                        else if (object.peclave == 124) this.verpago = true;
                    });
                });

                let formData = new FormData();
                formData.append("reporte", this.reporte.nrreporte);
                formData.append("indice", this.reporte.svindice);
                await TramitePago.ObtenerAutorizar(this, formData).then((data) => {
                    this.psid = data;
                });
            },
            async Autorizar() {
                this.reporte.urlname = this.$route.name;
                this.reporte.psid = this.psid;
                await MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, "reporte");
                this.$router.push({ path: this.asistenciaurl + '/Garantias/AutorizarPago' });
                //switch (this.reporte.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `AutorizarPagoExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `AutorizarPagoRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `AutorizarPagoRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `AutorizarPagoRCMedico` });
                //        break;
                //    default:
                //        break;
                //}
            },
            ValorMoneda(monto, moneda) {
                return MetodosGenerales.regresarValorMoneda(monto, moneda);
            },
            Foco() {
                this.msg = false;
            },
            AccesoFirma() {
                this.modal = true;
            },
            CerrarModal() {
                this.modal = false;
                this.firma = "";
                this.texto = "";
            },
            ValidarFirma() {
                let formdatos = new FormData();
                formdatos.append("usfirma", this.firma);

                if (this.firma.length == 0) {
                    this.msg = true;
                    this.texto = "Campo de requerido";
                } else if (this.firma.length < 8 /*|| this.firma.length > 16*/) {
                    this.msg = true;
                    this.texto =
                        "El número de caracteres debe ser un mínimo de 8 y menor a 17";
                } else {
                    this.loading = true;
                    TramitePago.ValidaFirmaElectronica(this, formdatos).then((dato) => {
                        this.reporte.urlname = this.$route.name;
                        MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, "param");
                        if (dato) {
                            this.modal = false;
                            this.$router.push({ path: this.asistenciaurl + '/Garantias/PresolicitudPago' });
                            //switch (this.reporte.aiclave.toString()) {
                            //    case "1":
                            //        this.$router.push({ name: `PresolicitudPagoExpJur` });
                            //        break;
                            //    case "24":
                            //        this.$router.push({ name: `PresolicitudPagoRobo` });
                            //        break;
                            //    case "23":
                            //        this.$router.push({ name: `PresolicitudPagoRLV` });
                            //        break;
                            //    case "5":
                            //        this.$router.push({ name: `PresolicitudPagoRCMedico` });
                            //        break;
                            //}
                        } else {
                            this.msg = true;
                            this.texto = "Su firma electrónica es incorrecta";
                        }
                        this.firma = "";
                        this.loading = false;
                    });
                }
            },
        },
        async mounted() {
            this.changeReporteMenuOption("Garantías");
            this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");

            //let formData2 = new FormData();
            //formData2.append("nrreporte", this.reporte.nrreporte);
            //formData2.append("svindice", this.reporte.svindice);
            //await Asistencia.ObtenerUrl(formData2).then(data => {
            //    if (data.success == true) {
            //        this.asistenciaurl = data.result;
            //    }
            //    else
            //        this.asistenciaurl = '';
            //});
            this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
            let formData = new FormData();
            formData.append("reporte", this.reporte.nrreporte);
            formData.append("indice", this.reporte.svindice);
            this.validaPre = await General.ValidarReporte(this, formData);

            this.permisoPresoli();
            this.displayInputs = {
                nrreporte: this.reporte.nrreporte,
                svindice: this.reporte.svindice,
            };
        },
        //async created() {
        //    this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");

        //    this.displayInputs = {
        //        nrreporte: this.reporte.nrreporte,
        //        svindice: this.reporte.svindice,
        //    };
        //},
    };
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }

    .collapsable-container {
        background-color: white;
        max-height: auto !important;
    }

    .cellT {
        width: 11%;
    }

    .addMovimientoClassList .vs-collapse-item--header {
        padding-top: 6px !important;
        padding-bottom: 6px !important;
        background-color: #e0e0e0 !important;
    }

    .addMovimientoClassList .con-content--item {
        padding: 0px !important;
    }

    .v-expansion-panel--active {
        min-height: 1px !important;
    }
</style>
